import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
      },
    };
  }

  static getDiscounts(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/tyre_discounts/list_discounts", requestData, this.requestConfig());
  }

  static addDiscount(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/tyre_discounts/add", requestData, this.requestConfig());
  }

  static addBrandDiscount(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/tyre_discounts/add_brand", requestData, this.requestConfig());
  }

  static updateDiscount(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/tyre_discounts/update", requestData, this.requestConfig());
  }

  static updateBrandDiscount(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/tyre_discounts/update_brand", requestData, this.requestConfig());
  }

  static deleteDiscount(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/tyre_discounts/delete", requestData, this.requestConfig());
  }

  static deleteBrandDiscount(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/tyre_discounts/delete_brand", requestData, this.requestConfig());
  }

  static getCategories() {
    return axios.get(ENV.dealerBaseUrl + "/tyre_discounts/list_categories", this.requestConfig());
  }

  static getTiresBrands() {
    return axios.get(ENV.carBaseUrl + "/tyres/brands/list", this.requestConfig());
  }

  static getTyreTeamBrands(requestData) {
    return axios.post(ENV.tyreteamBaseURL + "/catalog/brands/list", requestData, this.requestConfig());
  }
}

export default Service;
